<template>
  <div class="my-side" data-automation="mySide">
    <i class="my-side-sliding" :style="slidingStyle"></i>
    <div
      :class="['my-side-item', { 'my-side-item-active': currentTab === item.name }]"
      v-for="(item, idx) in sideList"
      :key="`side${item.name}`"
      @click="handleClick(item, idx)"
    >
      <i :class="`my-side-icon iconfont ${item.icon}`"></i>{{ item.label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'MySide',
  props: {
    // 菜单列表
    list: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 侧边栏列表
    sideList() {
      if (this.list.length > 0) {
        return this.list;
      }

      return [
        { name: 'personal', label: this.$t('HT.userCenter.personal') },
        { name: 'myBill', label: this.$t('HT.userCenter.myBill') }
      ];
    },
    // 滑块演示
    slidingStyle() {
      const idx = this.sideList.findIndex((item) => item.name === this.currentTab);
      return {
        top: `${56 * idx}px`
      };
    }
  },
  data() {
    return {
      currentTab: this.$route.meta.active // 当前页
    };
  },
  methods: {
    handleClick(row) {
      if (this.currentTab === row.name) return;
      this.currentTab = row.name;
      this.$router.push(row.name);
      this.$emit('onClick');
    }
  }
};
</script>

<style lang="scss" scoped>
.my-side {
  position: relative;
  width: 240px;
  height: 100%;

  .my-side-sliding {
    position: absolute;
    top: 0;
    right: 0;
    width: 4px;
    height: 48px;
    background: $color-primary;
    transition: all 0.3s;
  }

  .my-side-item {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    width: 100%;
    height: 48px;
    margin-bottom: 8px;
    padding-right: 20px;
    color: $color-text;
    font-weight: 400;
    font-size: 14px;

    &.my-side-item-active {
      color: $color-primary;
    }

    &:hover {
      color: $color-primary;
    }

    .my-side-icon {
      margin-right: 8px;
    }
  }
}
</style>
